import { Person } from "@mui/icons-material";
import { Grid, Stack, Typography } from "@mui/material";
import { format } from "date-fns";
import CustomSimpleAccordion from "qubCommon/Accordions/CustomSimpleAccordion";
import TextInput from "src/qubCommon/Inputs/TextInput";

const ChildInfo = ({ child }) => {
  let formattedDob = null;
  try {
    formattedDob = child?.dob
      ? `${format(new Date(child.dob), "dd/MM/yyyy")} (${child?.age} ετών)`
      : "";
  } catch (error) {
    console.error("Error formatting date:", error);
  }

  const AccordionTitle = () => (
    <Stack direction="row" gap={1}>
      <Person color="primary" fontSize="small" sx={{ marginLeft: "2px" }} />
      <Typography color="primary" sx={{ fontWeight: 1000 }}>
        ΣΤΟΙΧΕΙΑ ΠΑΙΔΙΟΥ
      </Typography>
      <Typography color="primary" sx={{ marginLeft: "18px", fontWeight: 500 }}>
        {child?.fullName}
      </Typography>
    </Stack>
  );

  const AccordionContent = () => (
    <Grid container spacing={2} padding={1}>
      <Grid item xs={12} md={6}>
        <TextInput
          disabled
          name="child.fullName"
          label="Ονοματεπώνυμο"
          defaultValue={child?.fullName}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextInput
          disabled
          name="child.amka"
          label="ΑΜΚΑ"
          defaultValue={child?.amka}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextInput
          disabled
          name="child.gender"
          label="Φύλο"
          defaultValue={child?.gender?.name}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextInput
          disabled
          name="child.dob"
          label="Ημερομηνία Γέννησης"
          defaultValue={
            formattedDob
              ? formattedDob
              : child?.dob
              ? `${child.dob} (${child?.age} ετών)`
              : ""
          }
        />
      </Grid>
    </Grid>
  );

  return (
    <CustomSimpleAccordion
      title={<AccordionTitle />}
      content={<AccordionContent />}
    />
  );
};

export default ChildInfo;
